// @flow
import reportTypes from 'modules/analyticalReport/reportTypes';

const typesValues = Object.keys(reportTypes);

export default {
  path: '/relatorio-analitico',
  component: () => import('modules/analyticalReport/Index.vue'),
  children: [
    {
      path: '',
      name: 'ListReport',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            name: 'Visit',
            text: 'Visitas'
          },
          {
            text: 'Relatório Análitico',
            name: 'ListReport'
          }
        ]
      },
      component: () => import('modules/analyticalReport/List.vue')
    },
    {
      path: ':report',
      name: 'DownloadReport',
      component: () => import('modules/analyticalReport/Download.vue'),
      beforeEnter(to: Object, from: Object, next: Function) {
        const isValidType = typesValues.includes(to.params.report);

        if (isValidType) next();
        else next({ name: 'ListReport' });
      }
    }
  ]
};
